import axiosInstance from "./config";

export const getSuperAdminDashboard = async () => {
  const response = await axiosInstance.get("/superadmin/dashboard");
  return response.data;
};

export const getSuperAdminToday = async () => {
  const response = await axiosInstance.get("/superadmin/today");
  return response.data;
};

export const getSuperAdminEmployees = async () => {
  const response = await axiosInstance.get("/superadmin/employees");
  return response.data;
};

export const assignEmployeeToSuperAdmin = async (employeeId) => {
  const response = await axiosInstance.put(`/superadmin/employee/${employeeId}/assign`);
  return response.data;
};

export const removeEmployeeFromSuperAdmin = async (employeeId) => {
  const response = await axiosInstance.put(`/superadmin/employee/${employeeId}/remove`);
  return response.data;
};

export const getEmployeeAttendanceHistory = async (employeeId) => {
  const response = await axiosInstance.get(`/superadmin/employee/${employeeId}/attendance`);
  return response.data;
};

export const triggerTestDailyReport = async () => {
  const response = await axiosInstance.post("/superadmin/test-daily-report");
  return response.data;
};
